import { render, staticRenderFns } from "./adBanner.vue?vue&type=template&id=4bafae28&scoped=true&"
import script from "./adBanner.vue?vue&type=script&lang=js&"
export * from "./adBanner.vue?vue&type=script&lang=js&"
import style0 from "./adBanner.vue?vue&type=style&index=0&id=4bafae28&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bafae28",
  null
  
)

export default component.exports